import React, { useState, useEffect, useRef } from "react";
import { Container, Col, Nav, Row, Form, Button, Tab, Modal } from 'react-bootstrap';
import { connect, useDispatch } from "react-redux";
import UserDetails from './internalUserTabs/UserDetails';
import UserRoles from './internalUserTabs/UserRoles';
import PageSectionContainer from '../../../../components/layout/PageSectionContainer';
import { IActionResult, IAppState } from '../../../../redux/storeTypes';
import { Routes } from "../../../../routes";
import { Redirect } from 'react-router-dom';
import { User, UserClient, UserTypeEnum } from '../../../../models/User';
import {
    saveUserAction, SAVE_USER_REQUEST, SAVE_USER_SUCCESS, SAVE_USER_FAILURE
} from '../../../../redux/actions/users';
import { sendSuccessToastAction, sendErrorToastAction } from '../../../../redux/actions/toast';
import PermissionModule, { Permissions } from '../../../../components/usePermissions';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/pro-regular-svg-icons";
interface IUserTabsContainerProps {
    isFetching: boolean;
    isSaving: boolean;
    user: User;
    actionResult: IActionResult;
}

const UserTabsContainer = ({ isFetching, isSaving, actionResult, user }: IUserTabsContainerProps) => {
    const [redirect, setRedirect] = useState<string>("");
    const dispatch = useDispatch();
    const [validated, setValidated] = useState(false);
    const [showModal, setModal] = useState(false);
    let actionToken = "UserTabsContainer";

    const handlemodal = () => {
        setRedirect(Routes.OrgUsers.path)
    }

    const ref = useRef(null);
  
    const scroll = (scrollOffset: any) => {
      const node: any = ref.current!;
      node.scrollLeft += scrollOffset;
    };

    useEffect(() => {
        if (actionResult && actionResult.result && actionResult.type === SAVE_USER_REQUEST && actionResult.token === actionToken) {
            if (actionResult.result === SAVE_USER_SUCCESS) {
                dispatch(sendSuccessToastAction("User was successfully saved."));
                setRedirect(Routes.OrgUsers.path);
            } else if (actionResult.result === SAVE_USER_FAILURE) {
                dispatch(sendErrorToastAction("User could not be saved. Reason(s) : " + actionResult.message));
            }
        }

    }, [actionResult]);

    const handleSubmit = (event: any) => {
        const form = event.currentTarget;
        event.preventDefault();

        if (form.checkValidity() !== false) {
            if (!user) {
                user = new User();
            }

            user.userTypeEnum = UserTypeEnum.Navient;
            user.email = form.elements.emailAddress.value;
            user.firstName = form.elements.firstName.value;
            user.lastName = form.elements.lastName.value;
            user.phoneNumber = form.elements.phoneNumber.value;
            user.title = form.elements.title.value;
            user.userClients = [];

            let selectedClients = form.elements.selectedClients.value as string;
            let clientIds = selectedClients.split(",") as Array<string>;
            clientIds.forEach(clientId => { if (clientId.length > 0) {user.userClients.push(new UserClient(clientId))}});

            const { updatedAt,createdAt, ...modifiedUser } = user;
            dispatch(saveUserAction(modifiedUser, actionToken));
        }
        else {
            dispatch(sendErrorToastAction("Please check the user details."));
        }
        setValidated(true);
    };

    if (redirect != "") {
        return (<Redirect push to={redirect} />)
    } else {
        return (
            <>
                <Container fluid className="manage-container">
                    <Row>
                        <Col>
                            <PageSectionContainer>
                                <Form id='orgUserSubmit' noValidate validated={validated} onSubmit={handleSubmit} className="tab-form">
                                    <Tab.Container id="orgUsers" defaultActiveKey="orgUser">

                                        {/* BEGIN: Tabs */}
                                        <div className="tab-nav d-flex px-0">
                                          <Button variant="link" onClick={() => scroll(-300)} className="btn-scroll-left">
                                            <FontAwesomeIcon icon={faChevronLeft} size="xs" />
                                          </Button>
                                          <div className="scrollbarContainer" ref={ref}>
                                            <Nav className="flex-row flex-nowrap">
                                                <Nav.Item>
                                                    <Nav.Link eventKey="orgUser">Details</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="orgUserRole">Roles</Nav.Link>
                                                </Nav.Item>
                                            </Nav>
                                          </div>
                                          <Button variant="link" onClick={() => scroll(300)} className="btn-scroll-right">
                                            <FontAwesomeIcon icon={faChevronRight} size="xs" />
                                          </Button>
                                        </div>
                                        {/* END: Tabs */}

                                        <Tab.Content>
                                            <Tab.Pane eventKey="orgUser">
                                                <UserDetails {...user} />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="orgUserRole">
                                                <UserRoles {...user} />
                                            </Tab.Pane>
                                            <div className="manage-footer">
                                                <Form.Group controlId="saveUserAction" className="form-footer mb-0">
                                                    {
                                                        user?.msbId ?
                                                            <PermissionModule
                                                                permission={[Permissions.ManageNavientInternalUserUpdate]}
                                                            >
                                                                <Button form='orgUserSubmit' type="submit" disabled={isSaving}>
                                                                    Save
                                                                </Button>
                                                            </PermissionModule>
                                                            :
                                                            <Button form='orgUserSubmit' type="submit" disabled={isFetching || isSaving}>
                                                                Save
                                                            </Button>
                                                    }
                                                    <Button form='orgUserSubmit' style={{ marginLeft: 'auto' }} variant="link" onClick={handlemodal}>
                                                        Cancel
                                                    </Button>
                                                </Form.Group>
                                            </div>
                                        </Tab.Content>
                                    </Tab.Container>
                                </Form>
                            </PageSectionContainer>
                        </Col>
                    </Row>
                </Container>

                <Modal show={showModal}>
                    <Modal.Dialog className="internalUserDialog">
                        <Modal.Body>
                            <Form.Group controlId="deleteOrgUser">
                                <Form.Label>Cancel user changes</Form.Label>
                            </Form.Group>
                            <Form.Group controlId="deleteOrgUser">
                                <Form.Label>Are you sure you want to cancel the changes to this user?</Form.Label>
                            </Form.Group>
                            <Form.Group className="internalUserDialogButtons">
                                <Button variant="outline-secondary" onClick={() => setModal(false)}>Cancel</Button>
                                <Button className="internalUserDeleteConfirm" onClick={() => { setRedirect(Routes.OrgUsers.path) }}>
                                    Confirm
                                </Button>
                            </Form.Group>
                        </Modal.Body>
                    </Modal.Dialog>
                </Modal>
            </>
        )
    }
}

const mapStateToProps = (state: IAppState) => {
    return {
        isFetching: state.users.isFetching,
        isSaving: state.users.isSaving,
        user: state.users.user,
        actionResult: state.users.actionResult
    };
};

export default connect(mapStateToProps)(UserTabsContainer);